import { StarIcon } from '@/components/icon';
import { LANGUAGES_SUPPORTED } from '@/types/enums';
import { isPathEk } from '@/utils/routes';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface Props {
    item: any,
    active?: boolean,
    onCallBack?: Function
}
export default observer(function BikeItem({ item, active = false, onCallBack }: Props) {
    // hook
    const { t, i18n: { language } } = useTranslation();
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // functions

    const getBikeManufacture = (bike: any, isEk: boolean): string => {
        if (isEk) {
            return bike?.bikeManufacture?.id;
        }

        if (language === LANGUAGES_SUPPORTED.Japanese) {
            return bike?.bikeManufacture?.name_jp || '--';
        } else {
            return bike?.bikeManufacture?.name || '--';
        }
    };

    // const
    const imgUrl = item?.vehicleImageRight || item?.vehicleImageLeft || item?.vehicleImageBefore || item?.vehicleImageAfter || '';

    return (
        <div
            className={classNames(
                'bg-background px-[min(20px,4.2vw)] py-[min(30px,5.2vw)] border border-border-gray2 rounded-[9.255px] flex flex-col gap-[min(16px,3.8vw)]',
                active && 'border-primaryWeb border-[2.75px] shadow-shadow-3 drop-shadow-xl',
                onCallBack && 'cursor-pointer'
            )}
            onClick={() => {
                onCallBack && onCallBack(item);
            }}
        >
            <div className='flex-none w-full relative'>
                <div
                    className='h-[180px] w-full bg-no-repeat bg-center bg-cover bg-background-img rounded-[7.712px]'
                    style={{
                        backgroundImage: `url(${imgUrl || ''})`
                    }}
                />
                {
                    item.isRecommendation && (
                        <div className='bg-primaryWeb rounded-[100px] px-[min(20px,3vw)] py-[min(8px,1.3vw)] absolute left-2.5 top-2.5 flex items-center gap-1.5'>
                            <StarIcon />
                            <div className='text-fs-mid12 text-text-white leading-none'>{t('words_title.recomment')}</div>
                        </div>
                    )
                }
            </div>
            <div className='box-title line-clamp-1'>{item?.bikeModel || '--'}</div>
            <div className='leading-lh-nor14 text-fs-mid14 font-normal'>
                <div className='grid grid-cols-6 items-center border-x border-b border-border-gray2 border-t'>
                    <div className='col-span-3 px-[min(20px,2.7vw)] py-[min(10px,2vw)] flex break-words items-center xsm:justify-end justify-center bg-[#F8F7F1] text-left border-r border-border-gray2 h-full'>
                        {t('field.manufacturer')}
                    </div>
                    <div className='col-span-3 px-[min(10px,2vw)] py-[min(10px,2vw)] flex items-center justify-center text-center'>
                        {getBikeManufacture(item, isEk)}
                    </div>
                </div>
                {!isEk && (
                    <>
                        <div className='grid grid-cols-6 items-center border-x border-b border-border-gray2'>
                            <div className='col-span-3 px-[min(20px,2.7vw)] py-[min(10px,2vw)] flex break-words items-center xsm:justify-end justify-center bg-[#F8F7F1] text-left border-r border-border-gray2 h-full'>
                                {t('field.engine_size')}
                            </div>
                            <div className='col-span-3 px-[min(10px,2vw)] py-[min(10px,2vw)] flex items-center justify-center text-center'>
                                {
                                    t(`words_title.${item?.bikeCapacity?.code}`)
                                }
                            </div>
                        </div>
                        <div className='grid grid-cols-6 items-center border-x border-b border-border-gray2'>
                            <div className='col-span-3 px-[min(20px,2.7vw)] py-[min(10px,2vw)] flex break-words items-center xsm:justify-end justify-center bg-[#F8F7F1] text-left border-r border-border-gray2 h-full'>
                                {t('field.gearbox')}
                            </div>
                            <div className='col-span-3 px-[min(10px,2vw)] py-[min(10px,2vw)] flex items-center justify-center text-center'>
                                {item.bikeTransmission?.toUpperCase()}
                            </div>
                        </div>
                    </>
                )}
                <div className='grid grid-cols-6 items-center border-x border-b border-border-gray2'>
                    <div className='col-span-3 px-[min(20px,2.7vw)] py-[min(10px,2vw)] flex break-words items-center xsm:justify-end justify-center bg-[#F8F7F1] text-left border-r border-border-gray2 h-full'>
                        {t('field.type')}
                    </div>
                    <div className='col-span-3 px-[min(10px,2vw)] py-[min(10px,2vw)] flex items-center justify-center text-center'>
                        {language === LANGUAGES_SUPPORTED.Japanese ? (item?.bikeType.name_jp || '--') : (item?.bikeType.name || '--')}
                    </div>
                </div>
            </div>
        </div>
    );
});
